import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../store";

export interface LiteralState {
  refreshRequestId: number;
  literals: {
    [x: string]: any;
  };
}

const initialState: LiteralState = {
  refreshRequestId: 0,
  literals: {},
};

export const literalSlice = createSlice({
  name: "literals",
  initialState: initialState,
  reducers: {
    setLiterals: (state, action) => {
      const literals = action.payload;
      state.literals = literals;
    },
    setLangLiterals: (state, action) => {
      const { literals } = action.payload;
      const previousLiterals = state.literals;
      state.literals = { ...previousLiterals, ...literals };
    },
    requestLiteralRefresh: (state) => {
      state.refreshRequestId += 1;
    },
  },
});

const { setLiterals, setLangLiterals, requestLiteralRefresh } = literalSlice.actions;

export const setAppLiterals =
  (literals: any): AppThunk =>
  (dispatch) => {
    return dispatch(setLiterals(literals));
  };
export const setLangAppLiterals =
  (literals: any, callbackFunction: Function): AppThunk =>
  (dispatch) => {
    dispatch(setLangLiterals({ literals }));
    if (callbackFunction) callbackFunction();
  };
export const refreshAppLiterals = (): AppThunk => (dispatch) => {
  dispatch(requestLiteralRefresh());
};

export default literalSlice.reducer;
